var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-container",
                { attrs: { "grid-list-md": "" } },
                [
                  _c("StepTitle", [_vm._v("Stock Crítico")]),
                  _c("v-divider"),
                  _c("br"),
                  _c(
                    "v-layout",
                    {
                      staticStyle: { "padding-right": "0px" },
                      attrs: { row: "", wrap: "" }
                    },
                    [
                      _c("v-flex", { attrs: { xs12: "", sm6: "", md6: "" } }, [
                        _c(
                          "div",
                          { attrs: { align: "left" } },
                          [
                            _c("BuscadorOperacionCrud", {
                              attrs: {
                                filter:
                                  _vm.gridApi &&
                                  _vm.gridApi.setQuickFilter.bind(_vm.gridApi)
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _c(
                        "v-flex",
                        {
                          staticStyle: { "padding-right": "0px" },
                          attrs: { xs12: "", sm6: "", md6: "" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "padding-top": "6px",
                                "padding-right": "0px"
                              },
                              attrs: { align: "right" }
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticStyle: {
                                    "padding-right": "20px",
                                    display: "block",
                                    margin: "0 0 0 auto",
                                    "margin-top": "15px"
                                  },
                                  attrs: { color: "#ffe800" },
                                  on: { click: _vm.crear_stock }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticStyle: { color: "black" },
                                      attrs: { dark: "", left: "" }
                                    },
                                    [_vm._v("add_circle_outline")]
                                  ),
                                  _c(
                                    "span",
                                    { staticStyle: { color: "black" } },
                                    [_vm._v("Crear")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "telcostock", attrs: { align: "left" } },
                    [
                      _c("MantenedorGridSinCodigo", {
                        attrs: {
                          "grid-options": _vm.gridOptions,
                          "funcionalidad-id": _vm.funcionalidad
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.showReporteGeneradoEditar
        ? _c("div", { staticClass: "wrap-evidencia" }, [
            _c("div", { staticClass: "ModalEdit" }, [
              _c(
                "div",
                {
                  staticClass: "modalEnvio-content",
                  attrs: { id: "desactivadores" }
                },
                [
                  _c("div", [
                    _vm._m(0),
                    _c(
                      "div",
                      {
                        staticClass: "buttonClose buttonCloseEvidencia",
                        attrs: { align: "right" }
                      },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { flat: "", small: "", color: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.closeReporteEditar()
                              }
                            }
                          },
                          [
                            _c(
                              "v-icon",
                              { staticClass: "importExportBtnIcon" },
                              [_vm._v("close")]
                            ),
                            _vm._v("  \n              "),
                            _c(
                              "span",
                              { staticClass: "importExportBtnTexto" },
                              [_vm._v("Cerrar")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { attrs: { align: "center" } },
                      [
                        _c(
                          "v-flex",
                          { attrs: { md10: "" } },
                          [
                            _c(
                              "v-card",
                              { staticClass: "rounded-card" },
                              [
                                _c(
                                  "v-form",
                                  {
                                    ref: "form",
                                    staticClass: "col-md-12",
                                    attrs: { "lazy-validation": "" }
                                  },
                                  [
                                    _c(
                                      "v-container",
                                      {
                                        staticStyle: {
                                          padding: "30px 40px 50px 40px"
                                        },
                                        attrs: { "grid-list-md": "" }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "boton_crear" },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass: "icon",
                                                staticStyle: {
                                                  "background-color":
                                                    "rgb(255, 108, 0)",
                                                  "border-color":
                                                    "rgb(255, 108, 0)",
                                                  "padding-right": "20px",
                                                  display: "block",
                                                  margin: "0 0 0 auto"
                                                },
                                                on: { click: _vm.editarStock }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "white"
                                                    }
                                                  },
                                                  [_vm._v("Guardar")]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "FormFieldsContainer",
                                          { attrs: { titulo: "Editar Stock" } },
                                          [
                                            _vm._t("prependInformacionGeneral"),
                                            _c(
                                              "v-flex",
                                              {
                                                attrs: {
                                                  xs4: "",
                                                  sm4: "",
                                                  md4: ""
                                                }
                                              },
                                              [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    label:
                                                      _vm.formFields.sim.label,
                                                    disabled: ""
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formFields.sim.value,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.formFields.sim,
                                                        "value",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formFields.sim.value"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-flex",
                                              {
                                                attrs: {
                                                  xs4: "",
                                                  sm4: "",
                                                  md4: ""
                                                }
                                              },
                                              [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    label:
                                                      _vm.formFields.stock.label
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formFields.stock
                                                        .value,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.formFields.stock,
                                                        "value",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formFields.stock.value"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ]
              )
            ])
          ])
        : _vm._e(),
      _vm.showReporteGeneradoCrear
        ? _c("div", { staticClass: "wrap-evidencia" }, [
            _c("div", { staticClass: "ModalEdit" }, [
              _c(
                "div",
                {
                  staticClass: "modalEnvio-content",
                  attrs: { id: "desactivadores" }
                },
                [
                  _c("div", [
                    _vm._m(1),
                    _c(
                      "div",
                      {
                        staticClass: "buttonClose buttonCloseEvidencia",
                        attrs: { align: "right" }
                      },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { flat: "", small: "", color: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.closeReportecrear()
                              }
                            }
                          },
                          [
                            _c(
                              "v-icon",
                              { staticClass: "importExportBtnIcon" },
                              [_vm._v("close")]
                            ),
                            _vm._v("  \n              "),
                            _c(
                              "span",
                              { staticClass: "importExportBtnTexto" },
                              [_vm._v("Cerrar")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { attrs: { align: "center" } },
                      [
                        _c(
                          "v-flex",
                          { attrs: { md10: "" } },
                          [
                            _c(
                              "v-card",
                              { staticClass: "rounded-card" },
                              [
                                _c(
                                  "v-form",
                                  {
                                    ref: "form",
                                    staticClass: "col-md-12",
                                    attrs: { "lazy-validation": "" }
                                  },
                                  [
                                    _c(
                                      "v-container",
                                      {
                                        staticStyle: {
                                          padding: "30px 40px 50px 40px"
                                        },
                                        attrs: { "grid-list-md": "" }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "boton_crear" },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass: "icon",
                                                staticStyle: {
                                                  "background-color":
                                                    "rgb(255, 108, 0)",
                                                  "border-color":
                                                    "rgb(255, 108, 0)",
                                                  "padding-right": "20px",
                                                  display: "block",
                                                  margin: "0 0 0 auto"
                                                },
                                                on: { click: _vm.crearStock }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "white"
                                                    }
                                                  },
                                                  [_vm._v("Guardar")]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "FormFieldsContainer",
                                          { attrs: { titulo: "Crear Stock" } },
                                          [
                                            _vm._t("prependInformacionGeneral"),
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass: "desplegable",
                                                attrs: {
                                                  xs4: "",
                                                  sm4: "",
                                                  md4: ""
                                                }
                                              },
                                              [
                                                _c("v-autocomplete", {
                                                  attrs: {
                                                    label:
                                                      _vm.formFields.sim.label,
                                                    items: _vm.tipolist,
                                                    "item-text": "tiposimname",
                                                    "item-value": "tiposimid"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formFields.sim.value,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.formFields.sim,
                                                        "value",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formFields.sim.value"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-flex",
                                              {
                                                attrs: {
                                                  xs4: "",
                                                  sm4: "",
                                                  md4: ""
                                                }
                                              },
                                              [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    label:
                                                      _vm.formFields.stock.label
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formFields.stock
                                                        .value,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.formFields.stock,
                                                        "value",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formFields.stock.value"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ]
              )
            ])
          ])
        : _vm._e(),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogConfirmacion,
          nombre: _vm.nombreStockElminar,
          titulo: "Eliminar el Stock de " + _vm.nombreStockElminar,
          mensaje: _vm.$t(
            "Después de realizada la acción no se podrá reversar."
          ),
          textoBtnSi: _vm.$t("mensajes.crud.crear.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.crear.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallback($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titleEvidencia" }, [
      _c("h2", { staticClass: "importExportBtnIcon" }, [_vm._v("Editar Stock")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titleEvidencia" }, [
      _c("h2", { staticClass: "importExportBtnIcon" }, [_vm._v("Crear Stock")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }